var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C15.6025 0 16.0909 0.488417 16.0909 1.09091V2.90909H17.9091C18.5116 2.90909 19 3.39751 19 4C19 4.60249 18.5116 5.09091 17.9091 5.09091H16.0909V6.90909C16.0909 7.51158 15.6025 8 15 8C14.3975 8 13.9091 7.51158 13.9091 6.90909V5.09091H12.0909C11.4884 5.09091 11 4.60249 11 4C11 3.39751 11.4884 2.90909 12.0909 2.90909H13.9091V1.09091C13.9091 0.488417 14.3975 0 15 0ZM2 3H9.70003C9.57118 3.3077 9.5 3.64554 9.5 4C9.5 5.43092 10.66 6.59091 12.0909 6.59091H12.4091V6.90909C12.4091 8.34001 13.5691 9.5 15 9.5C15.8053 9.5 16.5248 9.1326 17 8.55627V17C17 18.105 16.105 19 15 19H2C0.895 19 0 18.105 0 17V5C0 3.895 0.895 3 2 3ZM3.9674 14.4671L5.4714 12.0811C5.8204 11.5281 6.5974 11.4531 7.0454 11.9291L8.1204 13.0711L9.2474 10.6761C9.5944 9.9381 10.6324 9.9041 11.0274 10.6181L13.1814 14.5161C13.5494 15.1831 13.0664 16.0001 12.3054 16.0001H4.8134C4.0254 16.0001 3.5474 15.1331 3.9674 14.4671ZM5 9C6.10457 9 7 8.10457 7 7C7 5.89543 6.10457 5 5 5C3.89543 5 3 5.89543 3 7C3 8.10457 3.89543 9 5 9Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.391119fa8e384f61b94c4c702e27125b.svg";
export { ForwardRef as ReactComponent };